<template>
<v-footer height="auto" class="pb-0" fixed :app="false" :inset="true" style="background-color: transparent;">
    <v-content class="my-0 py-0">
        <v-container fluid :class="{'py-0':$vuetify.breakpoint.mdAndUp, 'pa-0':$vuetify.breakpoint.smAndDown}">
            <v-card flat :class="{'py-3':$vuetify.breakpoint.mdAndUp, 'pa-2':$vuetify.breakpoint.smAndDown}">
                <slot name="header"></slot>
                <div class="align-center justify-space-between d-flex">
                    <slot name="left">
                        <v-btn v-if="create" class="btn-shine red--text" text :small="$vuetify.breakpoint.smAndDown" @click="emitDelete()">
                            <v-icon color="red">delete</v-icon>
                            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('button.delete') }}</span>
                        </v-btn>
                    </slot>
                    <v-spacer></v-spacer>
                    <slot name="right">
                        <v-btn v-if="!update" text :small="$vuetify.breakpoint.smAndDown" @click="emitRefresh()">
                            {{ $t('button.cancel') }}
                        </v-btn>
                        <v-btn :icon="$vuetify.breakpoint.smAndDown" class="mx-1" :small="$vuetify.breakpoint.smAndDown" color="primary" :disabled="update" :loading="loading" @click="emitSave()">
                            <v-icon>save</v-icon>
                            <span class="pl-2" v-if="$vuetify.breakpoint.smAndUp">{{ $t('button.save') }}</span>
                        </v-btn>
                    </slot>
                </div>
            </v-card>
        </v-container>
    </v-content>
</v-footer>
</template>

<script>
export default {
    name: "IMFooter",
    props: {
        update: {
            type: Boolean,
            default: false
        },
        create: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        emitDelete() {
            this.$emit('delete');
        },
        emitRefresh() {
            this.$emit('refresh');
        },
        emitSave() {
            this.$emit('save');
        }
    }
}
</script>
